export default {
  meta: {
    title: '踩点任务管理',
    url: '/footprinting/manage', // 埋点用，记录所属模块
    // eventId: '829ea0fc-8ad3-4b9d-abbe-c2d88f0db985'
  },
};
